"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        width: 236,
        height: 350,
        backgroundColor: '#3498db',
    },
};
var description = 'You can style it as well.';
var code = "import React from 'react';\nimport { Drawer } from 'jsc-react-ui';\n\nconst style = {\n  base: {\n    width: 236,\n    height: 350,\n    backgroundColor: '#3498db',\n  },\n};\n\nconst DrawerExample = () => <Drawer style={style} />;";
exports.StylingExampleDrawer = function () { return (React.createElement(common_1.Example, { title: "Styling", description: description, code: code },
    React.createElement(components_1.Drawer, { style: componentStyle.base }))); };
exports.StylingExampleDrawer.displayName = 'StylingExampleDrawer';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerPage/StylingExampleDrawer.tsx
// module id = 661
// module chunks = 0